'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PhoneNumber = function () {
  function PhoneNumber() {
    'ngInject';

    _classCallCheck(this, PhoneNumber);

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  _createClass(PhoneNumber, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      ctrl.$validators.phoneNumber = function (modelValue) {
        if (!(modelValue && modelValue.length)) {
          return true;
        }

        var pattern = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
        return modelValue.match(pattern);
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      'ngInject';

      return new PhoneNumber();
    }
  }]);

  return PhoneNumber;
}();

exports.default = PhoneNumber;


// WEBPACK FOOTER //
// ./common/directives/validation/phone-number.js